module.exports = __webpack_public_path__ + "img/chunhuilu.72dfcf99.png";